import { Grid, Typography, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import AdvisorTable from "../../components/AdvisorTable/AdvisorTable";
import { User } from "../../models/User.model";
import { su, getAdvisorsStats } from "../../store/actions";
import { AdvisorStats, RootState } from "../../types/RootState";
import { PageConnected } from "../Page/Page";
import { styles } from "./PageAdvisors.style";

interface PageAdvisorsProps extends WithStyles<typeof styles> {
    advisors: User[];
    advisorsStats?: { [userId: string]: AdvisorStats };
    su: typeof su;
    getAdvisorsStats: typeof getAdvisorsStats;
}

class PageAdvisors extends React.Component<PageAdvisorsProps> {
    constructor(props: PageAdvisorsProps) {
        super(props);
        props.getAdvisorsStats();
    }
    public render() {
        const { classes } = this.props;

        return (
            <PageConnected>
                <Grid container={true} spacing={16} className={classes.container}>
                    <Grid item={true} sm={8}>
                        <Typography className={classes.title} variant="display1">
                            Mes commerciaux
                        </Typography>
                    </Grid>
                </Grid>
                <div className={classes.table}>
                    <AdvisorTable
                        advisors={this.props.advisors}
                        advisorsStats={this.props.advisorsStats}
                        onSurrogateClick={(advisor) => this.props.su(advisor)}
                    />
                </div>
            </PageConnected>
        );
    }
}

export const PageAdvisorsConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: PageAdvisorsProps) => ({
            ...ownProps,
            advisors: state.me.user.advisors,
            advisorsStats: state.me.advisorsStats,
        }),
        { su, getAdvisorsStats }
    )
)(PageAdvisors);

// For stories
export const PageAdvisorsStyled = withStyles(styles)(PageAdvisors);



// WEBPACK FOOTER //
// ./src/pages/PageAdvisors/PageAdvisors.tsx